import { getThemeValue } from "../utils/helpers";

export const useCurrency = () => {
  const currency = getThemeValue(["config", "currency"], "₹");
  return currency;
};
